import React from "react";

const Home = () => {
  return (
    <>
      <img
        className="spongebob-404"
        src="/spongebob-404.webp"
        alt="Spongebob 404"
      />
      <br />
      <h1>404 - Page Not Found</h1>
    </>
  );
};

export default Home;
